import { Button, ButtonMode, Icon, ICONS, Tooltip, colors } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import NoContent from '../../../NoContent/NoContent';
import { USER_LIMIT_EXCEEDED_MESSAGE } from '../../Watchlist/Watchlist.logic';
import { useWatchListTableContext } from '../WatchlistTableContext';

import styles from './NoDataComponent.module.scss';

const cx = classNames.bind(styles);

export interface NoDataComponentProps {
  isUserLimitExceeded: boolean;
  onAddIssuersWithCompaniesTool: () => void;
  onUploadIssuers: () => void;
}

const renderButton = ({ disabled, tooltipDisabled, title, onClick, iconName, tooltip, dataTestId }) => {
  return (
    <Tooltip disabled={tooltipDisabled} content={tooltip}>
      <span>
        <Button
          dataTestId={dataTestId}
          disabled={disabled}
          mode={ButtonMode.PLAIN}
          onClick={onClick}
          className={cx('action')}
        >
          <div className={cx('action-icon')}>
            <Icon height={16} width={16} name={iconName} color={colors.primary800} />
          </div>
          <div className={cx('action-title')}>{title}</div>
        </Button>
      </span>
    </Tooltip>
  );
};

const NoDataComponent = ({
  isUserLimitExceeded,
  onAddIssuersWithCompaniesTool,
  onUploadIssuers,
}: NoDataComponentProps): ReactElement => {
  const { isNameBeingChanged } = useWatchListTableContext();

  const isButtonDisabled = isUserLimitExceeded || isNameBeingChanged;

  const renderContent = () => {
    return (
      <div className={cx('body')}>
        {renderButton({
          title: 'Upload a list of companies',
          iconName: ICONS.Upload,
          disabled: isButtonDisabled,
          tooltip: USER_LIMIT_EXCEEDED_MESSAGE,
          tooltipDisabled: !isUserLimitExceeded,
          onClick: onUploadIssuers,
          dataTestId: 'upload-companies',
        })}
        {renderButton({
          title: 'Create watchlist with companies tool',
          iconName: ICONS.Filters,
          disabled: isButtonDisabled,
          tooltip: USER_LIMIT_EXCEEDED_MESSAGE,
          tooltipDisabled: !isUserLimitExceeded,
          onClick: onAddIssuersWithCompaniesTool,
          dataTestId: 'add-companies',
        })}
      </div>
    );
  };

  return (
    <NoContent
      dataTestId="no-issuers-added"
      header="No Issuers Yet"
      infoMessage="When you add issuers to this watchlist, they will appear here."
    >
      {renderContent()}
    </NoContent>
  );
};

export default NoDataComponent;
